// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"3cdb9654","535":"43f853ce","621":"c22ec59b","629":"cf3d5130","640":"cbf75116"}[chunkId] + ".chunk.js";
};